import React, { useContext, useEffect } from 'react';
import { RulesContext } from './RulesProvider';
import { makeStyles } from '@material-ui/core';
import Chip from '../../../../../../components/Chip/Chip/Chip';
import { useHistory, useRouteMatch } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 0),
    display: 'flex',
    flexFlow: 'row wrap',
    '& > div:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
}));

const List = () => {
  const classes = useStyles();
  const { categories, loadCategories } = useContext(RulesContext);
  const history = useHistory();
  const { path } = useRouteMatch();

  const handleClick = (catId) => {
    const category = categories.find((cat) => cat._id === catId);
    history.push(`${path}/${catId}`, { category });
  };

  useEffect(() => {
    loadCategories();
  }, []);

  return (
    <div className={classes.root}>
      {categories?.length ? (
        categories?.map((category) => (
          <Chip
            clickable
            key={category._id}
            label={category?.name}
            color="primary"
            onClick={() => handleClick(category._id)}
          />
        ))
      ) : (
        <div>نقشی یافت نشد!</div>
      )}
    </div>
  );
};

export default React.memo(List);
